import React, { useCallback, useEffect, useMemo } from 'react';
import { Select } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { changeDimension } from '../stateManagement/actions/report';
import ActionTypes from '../stateManagement/actions/types';
import { ScissorOutlined } from '@ant-design/icons';

const { Option } = Select;
const EMPTY_DIMENSIONS = [];

const DimensionSelector = ({
    dimensions = EMPTY_DIMENSIONS,
    dimensionType = ActionTypes.CHANGE_DIMENSION,
    defaultValue = 'provider',
    fullSize = false
}) => {
    const dispatch = useDispatch();

    const stateKey = {
        [ActionTypes.CHANGE_DIMENSION]: 'dimension',
        [ActionTypes.R_CHANGE_DIMENSION_1]: 'r_dimension_1',
        [ActionTypes.R_CHANGE_DIMENSION_2]: 'r_dimension_2',
        [ActionTypes.R_CHANGE_DIMENSION_3]: 'r_dimension_3'
    }[dimensionType];

    const selectedValue = useSelector(
        (state) => state.reportReducer[stateKey]
    );

    // Folosim valoarea din Redux dacă există în opțiunile disponibile.
    // Șirul gol este valid pentru opțiunea "No dimension".
    const selectionIsValid = dimensions.some(
        (item) => item.value === selectedValue
    );

    const fallbackValue = dimensions.some(
        (item) => item.value === defaultValue
    )
        ? defaultValue
        : dimensions[0]?.value;

    const value = selectionIsValid
        ? selectedValue
        : fallbackValue;

    // Inițializăm sau corectăm Redux când valoarea lipsește
    // ori nu este disponibilă în lista curentă.
    useEffect(() => {
        if (
            stateKey &&
            !selectionIsValid &&
            fallbackValue !== undefined
        ) {
            dispatch(changeDimension(fallbackValue, dimensionType));
        }
    }, [
        dispatch,
        stateKey,
        selectionIsValid,
        fallbackValue,
        dimensionType
    ]);

    const onChange = useCallback((newValue) => {
        dispatch(changeDimension(newValue, dimensionType));
    }, [dispatch, dimensionType]);

    const dimensionOptions = useMemo(
        () => dimensions.map((item) => (
            <Option key={item.key} value={item.value}>
                {item.label}
            </Option>
        )),
        [dimensions]
    );

    return (
        <Select
            value={value}
            onChange={onChange}
            className={fullSize ? 'full-size-dimensions' : ''}
            suffixIcon={fullSize ? <ScissorOutlined /> : false}
        >
            {dimensionOptions}
        </Select>
    );
};

export default DimensionSelector;